import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import c from "classnames";
import { useMemo as O } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import S from "../../../../../core/Context/useCoreContext.js";
import { ButtonVariant as f } from "../../../Button/types.js";
import u from "../../../Typography/Typography.js";
import C from "../../../SVGIcons/ChevronDown.js";
import { TypographyElement as L, TypographyVariant as B } from "../../../Typography/types.js";
import { DROPDOWN_BUTTON_CLASS as p, DROPDOWN_BUTTON_ACTIVE_CLASS as R, DROPDOWN_BUTTON_HAS_SELECTION_CLASS as h, DROPDOWN_BUTTON_READONLY_CLASS as y, DROPDOWN_BUTTON_INVALID_CLASS as A, DROPDOWN_BUTTON_VALID_CLASS as E, DROPDOWN_BUTTON_ICON_CLASS as P, DROPDOWN_BUTTON_TEXT_CLASS as U, DROPDOWN_BUTTON_MULTI_SELECT_COUNTER_CLASS as g, DROPDOWN_BUTTON_COLLAPSE_INDICATOR_CLASS as x, DROPDOWN_BUTTON_CLASSNAME as I } from "../constants.js";
import { Fragment as W } from "../../../../../external/preact/dist/preact.module.js";
import b from "../../../Img/Img.js";
import w from "../../../Button/Button.js";
import { boolOrFalse as V } from "../../../../../utils/value/bool.js";
const F = ({
  active: e,
  disabled: m,
  className: i,
  filterable: n,
  toggleButtonRef: l,
  ...o
}) => {
  const r = O(() => n ? c(I, i) : i, [i, n]);
  return n ? /* @__PURE__ */ a("div", { ...o, className: r, ref: l }) : /* @__PURE__ */ a(
    w,
    {
      ...o,
      className: r,
      disabled: m,
      variant: f.SECONDARY,
      ref: l
    }
  );
}, Z = (e) => {
  var N;
  const { i18n: m } = S(), { active: i, filterable: n, multiSelect: l, placeholder: o, readonly: r, showList: d, withoutCollapseIndicator: _ } = e, s = O(() => (o == null ? void 0 : o.trim()) || m.get("select.filter.placeholder"), [m, o]), t = O(() => V(l) ? void 0 : i[0], [i, l]), D = O(() => {
    var T;
    return ((T = t == null ? void 0 : t.name) == null ? void 0 : T.trim()) || s;
  }, [t, s]);
  return /* @__PURE__ */ a(
    F,
    {
      active: i,
      disabled: r,
      "aria-disabled": r,
      "aria-expanded": d,
      "aria-haspopup": "listbox",
      className: c(p, {
        [R]: d,
        [h]: !!i.length,
        [y]: r,
        [A]: e.isInvalid,
        [E]: e.isValid
      }),
      filterable: n,
      onClick: r ? void 0 : e.toggleList,
      onKeyDown: r ? void 0 : e.onButtonKeyDown,
      role: n ? "button" : void 0,
      tabIndex: 0,
      title: D,
      toggleButtonRef: e.toggleButtonRef,
      type: n ? void 0 : "button",
      "aria-describedby": e.ariaDescribedBy,
      id: e.id ?? "",
      children: [
        d && n ? /* @__PURE__ */ a(
          "input",
          {
            "aria-autocomplete": "list",
            "aria-controls": e.selectListId,
            "aria-expanded": d,
            "aria-owns": e.selectListId,
            autoComplete: "off",
            className: "adyen-pe-filter-input",
            onInput: e.onInput,
            placeholder: s,
            ref: e.filterInputRef,
            role: "combobox",
            type: "text"
          }
        ) : /* @__PURE__ */ a(W, { children: [
          (t == null ? void 0 : t.icon) && /* @__PURE__ */ a(b, { className: P, src: t.icon, alt: t.name.trim() }),
          /* @__PURE__ */ a("span", { className: U, children: ((N = t == null ? void 0 : t.selectedOptionName) == null ? void 0 : N.trim()) || (t == null ? void 0 : t.name.trim()) || s }),
          l && e.appliedFilterNumber > 0 && /* @__PURE__ */ a("div", { className: g, children: /* @__PURE__ */ a(u, { el: L.SPAN, variant: B.BODY, stronger: !0, children: e.appliedFilterNumber }) })
        ] }),
        !_ && /* @__PURE__ */ a("span", { className: x, children: /* @__PURE__ */ a(C, { role: "presentation" }) })
      ]
    }
  );
};
export {
  Z as default
};
